import { Box, styled } from "@mui/material";

export const ProfileWrapper = styled(Box)(() => {
    return {
        overflow: "hidden",
        "& .title-box": {
            marginBlockEnd: "var(--basic-margin)",
        },
        "& .legend-wrapper>legend": {
            fontWeight: 400,
            fontSize: "20px",
            color: "#2C352D",
            paddingInline: 0,
        },
        "& .legend-wrapper, & .fieldset-wrapper": {
            padding: "var(--basic-padding) calc(var(--basic-padding)/1.5)",
            borderBottom: "1px solid #D7D7D7",
            overflow: "hidden",
        },
        "& .fieldset-wrapper": {
            "& label": {
                fontWeight: 400,
                fontSize: "20px",
                color: "#2C352D",
                flex: 0.3,
            },
            "& input": {
                minWidth: 0,
            }
        },
        "& .button-box": {
            marginBlockStart: "var(--basic-margin)"
        },
        "& .admin-avatar": {
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            objectFit: 'cover'
        },
        "@media screen and (min-width: 1024px)": {
            "& .fieldset-wrapper": {
                display: "flex",
                gap: "var(--flex-gap)",
                alignItems: "center",
            }
        }
    }
})